import { Box, Button, Center, Divider, Text, VStack } from '@chakra-ui/react'
import { colors } from '@hb/shared'
import { useMemo } from 'react'
import { useProfile } from '../../../../../../contexts/user/ProfileContext'
import { PatientEncountersSummary } from '../../../Patient/PatientEncountersSummary'
import { PatientInsuranceSummary } from '../../../Patient/PatientInsuranceSummary'
import { PatientAlerts } from './PatientAlerts'
import { PatientInfoPregnancySummary } from './PatientInfoPregnancySummary'
import { PatientName } from './PatientName'
import { PatientNotes } from './PatientNotes'

const GoToConsentForms = () => {
  const { goTo, consentForms } = useProfile()
  const { data } = consentForms
  const { numConsentForms, numSigned, progress } = useMemo(() => {
    const numConsentForms = Object.keys(data ?? {}).length
    const numSigned = Object.values(data ?? {}).filter(c => !!c.signedOn).length
    const progress = numConsentForms ? (numSigned / numConsentForms) * 100 : 0
    return { numConsentForms, numSigned, progress }
  }, [data])
  return (
    <Center p={2} w="100%">
      <Button
        onClick={() => goTo({ entity: { type: 'patient' }, tab: 'consent-forms' })}
        color={numConsentForms ? 'white' : 'gray.500'}
        textShadow={numConsentForms ? '1px 1px 3px #00000077' : 'none'}
        bg={numConsentForms ? `${colors.green.hex}88` : 'gray.50'}
        size="md"
        w="100%"
        border="1px solid"
        borderColor={numConsentForms ? colors.green.hex : 'gray.400'}
        position="relative">
        <Box
          position="absolute"
          top={0}
          left={0}
          bottom={0}
          w={`${progress}%`}
          bg={colors.green.hex}
        />
        <Text zIndex={1}>
          {numConsentForms
            ? `${numSigned}/${numConsentForms} Consent Form${numConsentForms === 1 ? '' : 's'} Signed`
            : 'No Consent Forms'}
        </Text>
      </Button>
    </Center>
  )
}

export const PatientInfo = () => (
  <VStack
    divider={<Divider borderColor="gray.400" _dark={{ borderColor: 'gray.700' }} />}
    spacing={0}
    bg={`${colors.pink.hex}77`}
    flexFlow="column"
    h="100%"
    w="100%">
    <PatientName />
    <VStack
      bg="whiteAlpha.600"
      w="100%"
      spacing={0}
      flexFlow="column"
      flex={1}
      overflowY="auto"
      minH="0"
      divider={<Divider borderColor="gray.400" _dark={{ borderColor: 'gray.700' }} />}>
      <PatientAlerts />
      <PatientInfoPregnancySummary />
      <PatientEncountersSummary />
      <PatientInsuranceSummary />
      <GoToConsentForms />
      <PatientNotes />
    </VStack>
  </VStack>
)
